module.exports = __webpack_public_path__ + "static/media/flow_condition_wallet.8bedfffd.svg";